import { CommonModule } from '@angular/common';
import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { JsonLdBuilderModule } from './builders';
import { JsonLdDirective } from './json-ld.directive';
import { StructuredDataFactory } from './structured-data.factory';

/**
 * Factory to build the structure data without any interaction with the UI.
 */
export function getStructuredDataFactory(injector: Injector): () => Promise<void> {
  const result = async () => {
    const factory = injector.get(StructuredDataFactory);
    factory.build();
  };
  return result;
}

@NgModule({
  imports: [CommonModule, JsonLdBuilderModule],
  declarations: [JsonLdDirective],
  exports: [JsonLdDirective],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = getStructuredDataFactory(inject(Injector));
      return initializerFn();
    }),
  ],
})
export class StructuredDataModule {}
